export const CSS_VARIABLES = 'cal-css-variables';
export const INTERESTING_CALENDARS_FEATURE = 'cal-interestingCalendar';
